// MindForge web — i18n primitive types.
//
// A Dict entry is either a static string or a function that accepts a
// placeholder bag and returns a string. We use `any` for the function
// args so each dictionary entry can declare its own specific signature
// (e.g. `({ n }: { n: number }) => ...`) without TS contravariance
// errors — runtime always passes `args ?? {}` and the translator at the
// call site knows the right shape.

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type Translator = string | ((args: any) => string);

export type Dict = Record<string, Translator>;

export type Locale = "en" | "es";

export const SUPPORTED_LOCALES: readonly Locale[] = ["en", "es"] as const;
